import Admin from './Admin';
import Client from './Client';

const routes = [...Admin, ...Client];

export const routeMap = {
    admin: Admin,
    client: Client,
};

export default routes;
